import { AnimatePresence, motion } from "motion/react";

const AnimatedIcon = ({ className = "", isOpen, hideText, svgIcon, text, delay, labelPos }) => {
    const variantsBg = {
        closed: {
          backgroundColor: "#FFFFFF",
          "--tw-scale-x": 0.1,
          "--tw-scale-y": 0.1,
          transition: { duration: 0.5 },
        },
        open: {
          "--tw-scale-x": 1,
          "--tw-scale-y": 1,
          backgroundColor: "#07182D",
          transition: { duration: 0.5, delay: delay },
        },
      };
      
      const variantsText = {
        initial: { 
          opacity: 0,
          fontSize: "2rem",
          lineHeight: "2.85rem",
          color: "#3d4e9b",
          transition: { duration: 0.3 },
        },
        closed: {
          opacity: 1,
          fontSize: "2rem",
          lineHeight: "2.85rem",
          color: "#3d4e9b",
          transition: { duration: 0.3 },
        },
        open: {
          opacity: 1,
          fontSize: "4.5rem",
          lineHeight: "5.375rem",
          color: "#FFFFFF",
          transition: { duration: 0.3, delay: delay + 0.2 },
        }
      };

      if (labelPos === "r" ) {
        variantsText.initial.left = "10.75rem";
        variantsText.open.left = "10.75rem";
        variantsText.closed.left = "6.75rem";
      } else {
        variantsText.initial.right = "27rem";
        variantsText.open.right = "27rem";
        variantsText.closed.right = "23rem";
      }
    
    return (

  <div className={className}>
    <div className="relative">
      {/* Fondo de opacidad */}
      <div className="w-78u h-78u rounded-full bg-white opacity-20 absolute top-0 left-0 transform -translate-x-1/2 -translate-y-1/2"></div>

      {/* Animación de fondo y contenedor */}
      <motion.div
        initial={isOpen ? "open" : "closed"}
        animate={isOpen ? "open" : "closed"}
        variants={variantsBg}
        className="w-292u h-292u rounded-full
        transform -translate-x-1/2 -translate-y-1/2
        flex items-center justify-center"
      >
        <div className="w-147u h-auto">{svgIcon}</div>
      </motion.div>

      {/* Animación de texto */}
      <AnimatePresence>
        {!hideText &&
        <motion.div
            initial="initial"
            animate={isOpen ? "open" : "closed"}
            exit="initial"
            variants={variantsText}
            className={
                `absolute -translate-y-1/2 font-extralight text-72u leading-78u top-0
                ${labelPos === "l" ?
                    "text-right" :
                    ""
                }`}
        >
            {text}
        </motion.div>
        }
      </AnimatePresence>
    </div>
  </div>
);
};

export default AnimatedIcon;